// Must precede every other import: it swaps axios's adapter before any service
// module calls axios.create() and captures the real one. See localMode/bootstrap.
import "./localMode/bootstrap";
import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/global.css";
import "./index.css";
import "./styles/index.scss";
// After the global styles, so form scrollbars can override the permanent bar.
import "./design-system/fadingScrollbars";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import rootRouter from "./router/routes";
import AnThemeProvider from "./theme/AnThemeProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AnThemeProvider>
    <RouterProvider router={rootRouter} />
  </AnThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();